import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Vendita from "@/pages/Vendita";
import Affitti from "@/pages/Affitti";
import Calcolatore from "@/pages/Calcolatore";
import Storia from "@/pages/Storia";
import Mutui from "@/pages/Mutui";
import ImmobileDettaglio from "@/pages/ImmobileDettaglio";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/vendita" element={<Vendita />} />
            <Route path="/affitti" element={<Affitti />} />
            <Route path="/calcolatore" element={<Calcolatore />} />
            <Route path="/storia" element={<Storia />} />
            <Route path="/mutui" element={<Mutui />} />
            <Route path="/immobile/:id" element={<ImmobileDettaglio />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
